import { render, staticRenderFns } from "./batch-email-actions-menu.vue?vue&type=template&id=397074c7&"
import script from "./batch-email-actions-menu.vue?vue&type=script&lang=js&"
export * from "./batch-email-actions-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports